import {CurrentUser } from 'app/classes';

export class LogoutWarningController implements ng.IController {
    public user: CurrentUser;
    public static $inject = [
        '$CurrentUser',
        '$scope',
        '$document',
        'time',
        'close'
    ];

    constructor(
        private $CurrentUser,
        private $scope,
        private $document,
        private time,
        private close) {
        $document.on('keydown', this.escHandler);

        $scope.$on('$destroy', () => {
            $document.off('keydown', this.escHandler);
        });
    }

    public logout = () => {
        this.$CurrentUser.destroySession();
        this.close();
    }

    public escHandler = (event) => {
        if (event.keyCode === 27) {
            this.close();
        }
    }

}
